export const validation = {
  socials: {
    min: 0,
    max: 7
  },
  footerLogo: 1
}
